import React from "react";
import logo from "../../assets/img/logo.svg";
import phone from "../../assets/img/ico/phone.svg";
import "../../assets/css/edit-profile.css";

import download from "../../assets/img/ico/download.svg";
import checkmark from "../../assets/img/ico/checkmark.svg";
import home from "../../assets/img/ico/home.svg";
import bookmark from "../../assets/img/ico/bookmark.svg";
import heart from "../../assets/img/ico/heart.svg";
import paperAndPen from "../../assets/img/ico/paper-and-pen.svg";
import plusSquare from "../../assets/img/ico/plus-square.svg";
import scanner from "../../assets/img/ico/scanner.svg";
import user from "../../assets/img/ico/user.svg";
import car from "../../assets/img/ico/car.svg";

export default function EditProfile() {

    // peut être remplacé par des true/false
    const [justificatifs, setJustificatifs] = React.useState({
        identity: "toto",
        diploma: null,
        cv: null,
        domicile: null,
        rib: null,
        vitale: null,
        medical: null,
        driving: null
    });

    return (
        <section className={"edit-profile-form"}>
            <div>
                <h2>Mon profil</h2>
                <div>
                    <img src={logo} alt="user profile picture"></img>
                    <div className={"edit"}>
                    <img src={plusSquare} alt="edit profile picture icon"></img>
                    </div>
                </div>
            </div>
            <div>
                <h3>Informations personnelles</h3>
                <div>
                    <label htmlFor="name">Nom</label>
                    <input type="text" id="name" name="name" placeholder="Nom" />
                </div>
                <div>
                    <label htmlFor="surname">Prénom</label>
                    <input type="text" id="surname" name="surname" placeholder="Prénom" />
                </div>
                <div>
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" placeholder="Email" />
                </div>
                <div>
                    <label htmlFor="phone">Téléphone</label>
                    <input type="tel" id="phone" name="phone" placeholder="Téléphone" />
                </div>
                <div>
                    <label htmlFor="address">Adresse postale</label>
                    <input type="text" id="address" name="address" placeholder="Adresse" />
                </div>
                <div>
                    <label htmlFor="password">Mot de passe</label>
                    <input type="password" id="password" name="password" placeholder="Mot de passe" />
                </div>
            </div>
            <div>
                <h3>Informations professionnelles</h3>
                <div>
                    <label htmlFor="sector">Secteur d'activité</label>
                    <input type="text" id="sector" name="sector" placeholder="Secteur d'activité" />
                </div>
                <div>
                    <label htmlFor="experience">Expérience professionnelle</label>
                    <input type="text" id="experience" name="experience" placeholder="Expérience professionnelle" />
                </div>
                <div>
                    <label htmlFor="skills">Compétences</label>
                    <input type="text" id="skills" name="skills" placeholder="Compétences" />
                </div>
                <div>
                    <label htmlFor="availabilities">Disponibilités</label>
                    <input type="text" id="availabilities" name="availabilities" placeholder="Disponibilités" />
                </div>
            </div>
            <div>
                <h3>Mes justificatifs</h3>
                <div className={"justificatifs"}>
                    <div><p>Justificatifs principaux</p></div>
                    <div>
                        <img src={user} />
                            <p>Justificatifs d'identités</p>
                        <img  src={justificatifs.identity ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={bookmark} />
                            <p>Diplôme</p>
                        <img  src={justificatifs.diploma ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={paperAndPen} />
                            <p>CV</p>
                        <img  src={justificatifs.cv ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={home} />
                            <p>Justificatifs de domicile</p>
                        <img  src={justificatifs.domicile ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={scanner} />
                            <p>Relevé d'Identité Bancaire</p>
                        <img  src={justificatifs.rib ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={plusSquare} />
                            <p>Carte vitale</p>
                        <img  src={justificatifs.vitale ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={heart} />
                            <p>Visite médicale</p>
                        <img  src={justificatifs.medical ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={car} />
                            <p>Permis de conduire</p>
                        <img  src={justificatifs.driving ? checkmark : download} alt="user justificatif" />
                    </div>
                </div>
            </div>
            <div>
                <button className={"btn fill green"}>Enregistrer</button>
                <button className={"btn empty"}>Annuler</button>
            </div>
        </section>
    )
}